import { useEffect, useRef } from 'react';

const CHECK_MS = 60_000;

export default function VersionChecker() {
  const currentVersion = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const res = await fetch(`/version.json?cb=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        const next = data?.version || null;

        if (currentVersion.current && next && currentVersion.current !== next) {
          window.location.reload();
          return;
        }
        currentVersion.current = next;
      } catch {
        // Ignore errors
      } finally {
        timerRef.current = window.setTimeout(fetchVersion, CHECK_MS);
      }
    };

    const onVisible = () => {
      if (document.visibilityState === 'visible') fetchVersion();
    };

    fetchVersion();
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return null;
}
